import '@bd-uikit-web/styles/_base.scss';
import './styles/main.scss';

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { createStore } from 'redux';
import { Provider } from 'react-redux';
import PlaylistReducer from './reducer/playlistReducer';

import SplashScreen from './pages/SplashScreen';
import Freemium from './pages/Fremium';
import Layout from './pages/Layout';
import Pair from './pages/Pair';
import Register from './pages/Register';
import Home from './pages/Home';
import InfoPage from './pages/InfoPage';
import Notice from './pages/Notice';
import Policy from './pages/Policy';
import Agreement from './pages/Agreement';
import bdReq from '../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../@packages/@bd-uikit-web/js-helpers/bdAuth';

bdReq.setApiUrl('https://api.blackdove.io');

bdAuth.setAppId("fdea8d89jufd89kfff");
bdAuth.setUserEndpoint('/me');

const store = createStore(
  PlaylistReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

render(
  (
    <Provider store={store} >
      <Layout>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={SplashScreen} />
            <Route path="/home" component={Home} />
            <Route path="/freemium" component={Freemium} />
            <Route path="/pair" component={Pair} />
            <Route path="/register" component={Register} />
            <Route path="/info-page" component={InfoPage} />
            <Route path="/notice/:id?" component={Notice} />
            <Route path="/agreement" component={Agreement} />
            <Route path="/policy" component={Policy} />
          </Switch>
        </BrowserRouter>
      </Layout>
    </Provider>
  ), document.getElementById('app'));
